import 'mapbox-gl/dist/mapbox-gl.css';
import { memo } from 'react';
import { Map as MapboxMap } from 'react-map-gl/mapbox';
import { MAP_CONFIGURATION, ROAD_MAP_TYPE } from '../../constants/map';
import { environment } from '../../environments/environment';
import './styles/mapbox.css';

type Props = Readonly<{
  center: {
    latitude: number;
    longitude: number;
  };
  markers?: React.ReactNode;
}>;

function StaticMap({ center, markers }: Props) {
  return (
    <MapboxMap
      id="staticMap"
      mapboxAccessToken={environment.mapboxAPIKey}
      initialViewState={{
        ...center,
        zoom: 14,
      }}
      mapStyle={MAP_CONFIGURATION[ROAD_MAP_TYPE].style}
      projection={{ name: 'mercator' }}
      scrollZoom={false}
      doubleClickZoom={false}
      minZoom={0}
      maxZoom={18}
      dragPan={false}
      cursor="default"
    >
      {markers}
    </MapboxMap>
  );
}

export default memo(StaticMap);
